import React, { Component } from "react";

import { connect } from "react-redux";

import { Link } from "react-router-dom";

import { Button } from "reactstrap";

//Import i18n
import { withTranslation } from "react-i18next";

// Redux Store
import { toggleRightSidebar } from "../../store/actions";
import { MODULE_SELECTOR_PAGE } from "../../routes/routeConstants";
import logoHorizontal from "../../assets/images/ja-eval_logo_horizontal_transparent.png";
import logoSymbol from "../../assets/images/ja-eval_symbol_transparent.png";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSocialPf: false,
            currentTime: new Date(),
        };
        this.toggleMenu = this.toggleMenu.bind(this);
    }
    /**
     * Toggle sidebar
     */
    toggleMenu() {
        this.props.toggleMenuCallback();
    }

    componentDidMount() {
        this.clockTimer = setInterval(() => {
            this.setState({ currentTime: new Date() });
        }, 1000);
    }

    componentWillUnmount() {
        if (this.clockTimer) {
            clearInterval(this.clockTimer);
        }
    }

    getUsername() {
        const authUser = localStorage.getItem("authUser");

        if (!authUser) {
            return "Admin";
        }

        try {
            const user = JSON.parse(authUser);
            const displayValue =
                user?.name ||
                user?.username ||
                user?.email ||
                user?.user?.name ||
                user?.user?.username ||
                user?.user?.email;

            if (!displayValue) {
                return "Admin";
            }

            const cleanName = displayValue.includes("@") ? displayValue.split("@")[0] : displayValue;

            return cleanName
                .split(/[._\s-]+/)
                .filter(Boolean)
                .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
                .join(" ");
        } catch (error) {
            console.error("Error parsing authUser from localStorage", error);
            return "Admin";
        }
    }

    render() {
        const username = this.getUsername();
        const isSidebarCollapsed = this.props.leftSideBarType === "condensed";
        const formattedTime = this.state.currentTime.toLocaleTimeString("fr-FR", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
        const formattedDate = this.state.currentTime.toLocaleDateString("fr-FR", {
            weekday: "short",
            day: "2-digit",
            month: "short",
        });

        return (
            <React.Fragment>
                <header id="page-topbar" className="header-enhanced vertical-header-enhanced">
                    <div className="navbar-header">
                        <div className="d-flex align-items-center header-primary-zone">

                            <div className="navbar-brand-box brand-box-enhanced">
                                <Link to={MODULE_SELECTOR_PAGE} className="logo logo-dark logo-enhanced brand-link" aria-label="Accueil JA-Eval">
                                    <img src={logoHorizontal} alt="JA-Eval" className="brand-logo-horizontal" />
                                    <img src={logoSymbol} alt="" className="brand-logo-symbol" aria-hidden="true" />
                                </Link>
                            </div>

                            <Button size="sm" color="none" type="button" onClick={this.toggleMenu} className="header-item waves-effect header-toggle vertical-sidebar-toggle" id="vertical-menu-btn" title={isSidebarCollapsed ? "Déployer le menu" : "Réduire le menu"} aria-label={isSidebarCollapsed ? "Déployer le menu" : "Réduire le menu"} aria-expanded={!isSidebarCollapsed}>
                                <i className="ri-menu-2-line" aria-hidden="true"></i>
                            </Button>

                        </div>

                        <div className="d-flex align-items-center header-actions">
                            <div className="header-session-info">
                                <span className="header-session-avatar">{username.charAt(0).toUpperCase()}</span>
                                <div>
                                    <span>{username}</span>
                                    <small>{formattedDate} - {formattedTime}</small>
                                </div>
                            </div>

                            <Button tag={Link} to="/logout" color="none" className="header-logout-button">
                                <i className="ri-shut-down-line"></i>
                                <span>Déconnexion</span>
                            </Button>

                        </div>
                    </div>
                </header>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { layoutType, leftSideBarType } = state.Layout;
    return { layoutType, leftSideBarType };
};

export default connect(mapStatetoProps, { toggleRightSidebar })(withTranslation()(Header));
